import React, { useState } from 'react';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';
import Pagination from './Pagination/Pagination'; // Assurez-vous que le chemin est correct
import { useNavigate } from 'react-router-dom';
import getBaseUrl from '../helpers/utility';

const ImportPersonnel = () => {
  const baseUrl = getBaseUrl();

  const [file, setFile] = useState(null);
  const [data, setData] = useState([]);
  const [doublons, setDoublons] = useState([]);


  const [personnels, setPersonnels] = useState([]);
  const navigate = useNavigate();
  let token = localStorage.getItem('accessToken');

  const [personnelsPerPage] = useState(50); // Nombre de personnels par page
  const [currentPage, setCurrentPage] = useState(1);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  /*   const handleImport = async () => {
  
  
      if (!file) {
        toast.warn('Veuillez sélectionner un fichier');
        return;
      }
  
      const formData = new FormData();
      formData.append('file', file);
  
      try {
        const response = await axios.post('/api/personnel/upload-excel', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        });
  
        setData(response.data);
        toast.success(response.data.message);
  
        const personnelCompagnie = await axios.get(`personnel?compagnieId=${response.data.data[0].compagnieId}`, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          }
        });
        
        setPersonnels(personnelCompagnie.data.personnels);
  
      } catch (error) {
        console.log(error);
        
        if (error.response && error.response.data) {
          const { message, error: backendError, exemples } = error.response.data;
      
          // Affichage du message principal d'erreur
          toast.error(`Erreur : ${message || backendError || "Erreur inconnue"}`);
      
          // Si le backend a renvoyé des exemples de personnels sans compagnie
          if (exemples && exemples.length > 0) {
            toast.warn(`Exemples sans compagnieId : ${exemples.join(', ')}`);
          }
      
          // Si ton backend renvoie aussi d'autres types d’erreurs (ex: invalidGrades)
          if (error.response.data.invalidGrades) {
            toast.error(`GradeId invalides : ${error.response.data.invalidGrades.join(', ')}`);
          }
      
        } else {
          toast.error("Une erreur s'est produite lors de l'importation.");
        }
      }
      setFile(null);
    };
   */
  const handleImport = async () => {
    if (!file) {
      toast.warn('Veuillez sélectionner un fichier');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    // 🔹 Afficher le toast "en cours" et récupérer son id
    const loadingToastId = toast.loading('Importation en cours...');

    try {
      const response = await axios.post('/personnel/upload-excel', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      setData(response.data);
      setDoublons(response.data.doublons);

      // 🔹 Remplacer le toast "en cours" par un toast de succès
      toast.update(loadingToastId, {
        render: response.data.message,
        type: 'success',
        isLoading: false,
        autoClose: 3000, // 3 secondes avant disparition
        closeOnClick: true,
      });

      const personnelCompagnie = await axios.get(
        `personnel?compagnieId=${response.data.data[0].compagnieId}`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPersonnels(personnelCompagnie.data.personnels);

    } catch (error) {
      console.log(error);

      let errorMessage = "Une erreur s'est produite lors de l'importation.";

      if (error.response && error.response.data) {
        // 🔥 Cas principal : erreur envoyée par ton backend 
        if (error.response.data.error) {
          errorMessage = error.response.data.error;
        }

        // Autres erreurs déjà gérées
        const { message, exemples, invalidGrades } = error.response.data;

        if (exemples && exemples.length > 0) {
          toast.warn(`Exemples sans compagnieId : ${exemples.join(', ')}`);
        }

        if (invalidGrades) {
          toast.error(`GradeId invalides : ${invalidGrades.join(', ')}`);
        }
      }

      // 🔹 Mise à jour du toast "loading" -> erreur
      toast.update(loadingToastId, {
        render: errorMessage,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
      });
    }

    setFile(null);
  };


  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(personnels.length / personnelsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div className="mt-3 container  ">
      <div className="bg-warning text-center rounded-lg p-4">
        <div className="row">
          <div className="col ">
            <h3>Importer des Personnels depuis un fichier Excel</h3>
            <input type="file" onChange={handleFileChange} accept=".xlsx, .xls" />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="col ">
              <button className="btn btn-primary btn-sm btn-group-lg btn-sm mt-5 " onClick={handleImport}>
                Importer les données
              </button>
            </div>
          </div>
        </div>
      </div>
      {personnels.length > 0 && (
        <>
          <div className="mt-2 alert alert-success"> Liste des personnels importés avec succés </div>
          <div className="row mt-2">
            <div className="col">
              <table className="table table-bordered table-sm">
                <thead className="thead-dark">
                  <tr>
                    <th>N°</th>
                    <th>Grade</th>
                    <th>NOM et prénom</th>
                    <th>Fonction</th>
                    <th>Ets ou Service</th>
                    <th>matricule</th>
                    <th>Bataillon</th>
                    <th>Compagnie</th>
                    <th>Images</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {personnels.map((personnel, key) => (
                    <tr key={personnel.id} className="animate__animated animate__flash">
                      <td>{key + 1} </td>
                      <td> {personnel.grade.name} </td>
                      <td> {personnel.nomprenom} </td>
                      <td> {personnel.fonction} </td>
                      <td>{personnel.etsouservice && personnel.etsouservice.name}</td>
                      <td> {personnel.matricule} </td>
                      <td>{personnel.compagnie && personnel.compagnie.bataillon.name}</td>
                      <td>{personnel.compagnie && personnel.compagnie.name}</td>
                      <td>{personnel.filename ? <img src={` ${baseUrl} /images/personnels/${personnel.filename}`} width="50px" height="50px" alt="" /> : <img src={`${baseUrl}/images/personnels/defaultImage.jpg`} width="50px" height="50px" alt="" />}</td>
                      <td className="col-md-1">
                        <i style={{ cursor: 'pointer' }} className="fa fa-eye mr-2" onClick={() => navigate(`/personnel/${personnel.id}`)}></i>
                        <i style={{ cursor: 'pointer' }} className="fa fa-pencil p-2 mr-2" onClick={() => navigate(`/personnel/edit/${personnel.id}`)}></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination personnelsPerPage={personnelsPerPage} totalPersonnels={personnels.length} paginate={paginate} currentPage={currentPage} />
            </div>
          </div>
        </>
      )}
      <div>
        {doublons && (doublons.premierPassage?.length > 0 || doublons.secondPassage?.length > 0) && (
          <div className="alert alert-danger mt-3">
            <h4>⚠️ Doublons détectés</h4>

            {doublons.premierPassage.length > 0 && (
              <>
                <h5>🔸 Doublons trouvés (1er passage)</h5>
                <ul>
                  {doublons.premierPassage.map((p, i) => (
                    <li key={i}>{p.nomprenom} — Matricule : {p.matricule}</li>
                  ))}
                </ul>
              </>
            )}

            {doublons.secondPassage.length > 0 && (
              <>
                <h5>🔸 Doublons non insérés (2e passage)</h5>
                <ul>
                  {doublons.secondPassage.map((p, i) => (
                    <li key={i}>{p.nomprenom} — Matricule : {p.matricule}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        )}

      </div>

    </div>
  );
};

export default ImportPersonnel;
